import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

 

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>Skills can be obtained through Hard Work. These are my skills.<br></br>Feel free to give reviews.</p>
                        <Carousel responsive={responsive} arrows autoPlay autoPlaySpeed={2000} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <div class="circle per-50">
                                    <div class="inner">50%</div>
                                </div>
                                <h5>Competitive Programming</h5>
                            </div>
                            <div className="item">
                                <div class="circle per-75">
                                    <div class="inner">75%</div>
                                </div>
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <div class="circle per-75">
                                    <div class="inner">75%</div>
                                </div>
                                <h5>Java</h5>
                            </div>
                            <div className="item">
                                <div class="circle per-50">
                                    <div class="inner">50%</div>
                                </div>
                                <h5>SQL</h5>
                            </div>

                            {/* <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h5>SQL</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>Competitive Programmer</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h5>C#</h5>
                            </div> */}
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}